// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const apiKey = "02-eACJETYkr9ftQKckM0gTTQRoDxp4ffhFqsqkaLBa6AzFuuLth0w=="

// Define a service using a base URL and expected endpoints
export const azureTestApi = createApi({
  reducerPath: 'azureTestApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://c2gmanual.azurewebsites.net/api/',
    prepareHeaders: (headers) => {
      headers.set("x-functions-key", apiKey)
      return headers
    }
  }),
  endpoints: (builder) => ({
    sayHello: builder.query({
      query: (sendWhat) => ({
        url: 'HelloWorld',
        method: 'POST',
        body: sendWhat
      }),
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useSayHelloQuery } = azureTestApi


// test function: https://c2gmanual.azurewebsites.net/api/HelloWorld?code=02-eACJETYkr9ftQKckM0gTTQRoDxp4ffhFqsqkaLBa6AzFuuLth0w==
// { "name": "c2g_Name" }